jQuery(function($)
{
    /**
	 * @type {object jQuery}
	 */
    let upButton = $('.js-quantity-count-up');

    /**
	 * @type {object jQuery}
	 */
    let downButton = $('.js-quantity-count-down');

    /**
	 * Increase quantity
	 * @param {object} event Event Data
	 */
    function stepUp(event)
    {
        event.preventDefault();

        let quantityInput = $(this).siblings('.js-quantity-count');
        let currentValue = parseInt(quantityInput.val(), 10);

        quantityInput.val(currentValue + 1);
    }

    /**
	 * Decrease quantity
	 * @param {object} event Event Data
	 */
    function stepDown(event)
    {
        event.preventDefault();

        let quantityInput = $(this).siblings('.js-quantity-count');
        let currentValue = parseInt(quantityInput.val(), 10);

        if (currentValue <= 0)
        {
            return;
        }

        quantityInput.val(currentValue - 1);
    }

    upButton.on('click', stepUp);
    downButton.on('click', stepDown);
});
